import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { Button } from "reactstrap";
import Slide from "./Components/Slide";
import * as Ionicons from "react-icons/io";
import TutorialImg1 from "../../assets/utils/images/tutorial/tutorial1.png";
import TutorialImg2 from "../../assets/utils/images/tutorial/tutorial2.png";
import TutorialImg3 from "../../assets/utils/images/tutorial/tutorial3.png";
import TutorialImg4 from "../../assets/utils/images/tutorial/tutorial4.png";
import TutorialImg5 from "../../assets/utils/images/tutorial/tutorial5.png";
import Hand from "../../assets/utils/images/tutorial/hand.png";

const Tutorial = ({ setTutorialCard }) => {
  const [show, setShow] = useState(true);
  const [nav, setNav] = useState();
  const slider = useRef();

  const settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
  };

  const CloseIcon = Ionicons["IoIosClose"];

  return (
    <>
      {show ? (
        <div className="tutorial">
          <CloseIcon
            fontSize="40px"
            onClick={() => {
              setShow(false);
              setTutorialCard("");
            }}
            className="tutorial_close_icon pointer"
          />
          <Slider {...settings} asNavFor={nav} ref={(slider) => setNav(slider)}>
            <div>
              <p className="tutorial_title mb-2">
                Social mapへようこそ
                <img
                  src={Hand}
                  style={{ display: "inline", width: 32, marginTop: -4 }}
                />
              </p>
              <p className="tutorial_text">
                日本最大のCSO(NGOやNPO)データベースSocial
                mapの基本機能を紹介します！
              </p>
              <img src={TutorialImg1} className="tutorial_img mt-3 mb-3" />
            </div>
            <div>
              <p className="tutorial_title mb-2">CSOを探してみよう！</p>
              <p className="tutorial_text">
                組織名、キーワード、 SDGs、 分野などから検索できます。
              </p>
              <img
                src={TutorialImg2}
                className="tutorial_img mt-3 mb-3"
                style={{ width: "80%", margin: "auto" }}
              />
            </div>
            <div>
              <p className="tutorial_title mb-2">業界を広く眺めてみよう！</p>
              <p className="tutorial_text">
                マップやトレンド(経年変化)からCSOの業界を知ることができます。
              </p>
              <img src={TutorialImg3} className="tutorial_img mt-3 mb-3" />
            </div>
            <div>
              <p className="tutorial_title mb-2">アクションに備えよう！</p>
              <p className="tutorial_text">
                無料登録をすると、個人の関心やお好みCSOリストを管理できます。
              </p>
              <img src={TutorialImg4} className="tutorial_img mt-3 mb-3" />
              <div
                style={{
                  textAlign: "center",
                  fontSize: 16,
                  marginBottom: 8,
                  fontWeight: 600,
                }}
              >
                <Link to="/pages/register">無料登録はコチラ</Link>
              </div>
            </div>
            <div>
              <p className="tutorial_title mb-2">組織としてアクション！</p>
              <p className="tutorial_text mb-2">
                組織登録をして、自組織を客観的に理解し分析できます。
              </p>
              <img src={TutorialImg5} className="tutorial_img mb-3" />
              <div
                style={{
                  textAlign: "center",
                  fontSize: 16,
                  marginBottom: 8,
                  fontWeight: 600,
                }}
              >
                <a href="https://forms.gle/oQpYqvZwAGkCvMQr9" target="_blank">
                  組織登録はコチラ
                </a>
              </div>
            </div>
          </Slider>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Tutorial;
